module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app-imagecropper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    attrs: {
      "id": "fileUpload",
      "type": "file",
      "hidden": "",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.chooseFiles()
      }
    }
  }, [_vm._v("Pilih Gambar")])])]), _vm._v(" "), (_vm.showCropModal) ? _c('app-modal', {
    attrs: {
      "withCancel": "true"
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCrop()
      },
      "ok": function($event) {
        return _vm.confirmCrop()
      },
      "hook:mounted": function($event) {
        return _vm.cropImage()
      }
    }
  }, [_c('img', {
    ref: "previewImage",
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "slot": "body",
      "src": _vm.previewImageUrl,
      "alt": "previewImage"
    },
    slot: "body"
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14e26b10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plugins/ImageCropper.vue
// module id = 1286
// module chunks = 0